import React from 'react'
import AllComponents from './components/AllComponents'
import Footer from './components/Footer'
import PageHeading from './Properties/PageHeading'
import SectionProperties from './Properties/SectionProperties'
import { CartProvider } from 'react-use-cart'

function Properties() {
  return (
    <CartProvider>
      <AllComponents />
      <PageHeading />
      <SectionProperties />
      <Footer />
    </CartProvider>
  )
}

export default Properties